import React from "react";
import { QuoteOneLine } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Image from "next/image";

interface QuoteOneLineProps {
  blok?: QuoteOneLine & SbBlokData;
}

const QuoteOneLineComponent: React.FC<QuoteOneLineProps> = ({ blok }) => {
  if (!blok) return null;

  const { quote, logo, photo, name, company } = blok || {};

  return (
    <div className="container">
      <div
        {...storyblokEditable(blok)}
        className="card card-lighter testimonial-card p-4 mt-5"
      >
        <blockquote className="unstyled mb-4 row align-items-center gx-4 mb-lg-0">
          <div className="col-lg-14 mb-4 mb-lg-0">
            {quote && <p className="quote mb-0">{quote}</p>}
          </div>
          <div className="col-md-auto col-lg-10 logo text-lg-center ms-auto d-flex align-items-center">
            {logo && logo.filename && (
              <div className="me-4">
                <Image
                  style={{ width: "100%", maxWidth: "123px", height: "auto" }}
                  alt={logo.alt || "Company logo"}
                  src={logo.filename}
                  width="123"
                  height="31"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  quality={75}
                />
              </div>
            )}
            <cite className="col-16 col-md-auto author d-flex align-items-center justify-content-end">
              {photo && photo.filename && (
                <Image
                  alt={photo.alt || name || "Profile photo"}
                  className="me-2"
                  src={photo.filename}
                  width="80"
                  height="80"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  quality={75}
                />
              )}
              {name && company && `${name}, ${company}`}
              {name && !company && name}
              {!name && company && company}
            </cite>
          </div>
        </blockquote>
      </div>
    </div>
  );
};

export default QuoteOneLineComponent;
